module.exports = __webpack_public_path__ + "house-classic-granite.85ed051c0eb22c7fbfea.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/assets/img/house-classic-granite.svg
// module id = ../../../../../src/assets/img/house-classic-granite.svg
// module chunks = main